import Modal from '@components/Modal'
import { Container, Grid, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import Image from 'next/image'
import React from 'react'
import QRCode from 'react-qr-code'
import { BrandVars } from '@quark/theme'
import { Close } from '@quark/icons'
import { ackoUrl } from '@components/WhatsappChallanNewFlow/constants'
import { DriveModalProps } from '@interfaces/home'
import styles from './DriveHero.module.scss'

const DriveModal = ({ show, setShow, modalData }: DriveModalProps) => {
  if (!show) return null
  return (
    <Modal show={show} setShow={setShow} className={styles.modal}>
      <Close height="16" width="16" color="#fff" className={styles.closeIcon} onClick={() => setShow(false)} />
      <Container borderRadius="radius-6xl" backgroundColor="base/elevated">
        <Grid gridTemplateColumns="2">
          <Container padding="spacing-40">
            <Flex size="fullHeight" flexDirection="column" gap="spacing-32" justifyContent="center">
              <Flex flexDirection="column" gap="spacing-8">
                <Text fontStyle="um_text-4xl/bold" color="base/primary" whiteSpace="pre">
                  {modalData?.title}
                </Text>
                <Text fontStyle="um_text-sm/normal" color="base/secondary">
                  {modalData?.subTitle}
                </Text>
              </Flex>
              <Flex flexDirection="column" gap="spacing-16">
                <Flex gap="spacing-16">
                  {modalData?.modalFeatures?.map((feature, i) => (
                    <Container
                      key={i}
                      backgroundColor="base/overlay"
                      borderRadius="radius-3xl"
                      padding="spacing-12"
                      textAlign="center">
                      <Flex flexDirection="column" alignItems="center" gap="spacing-12">
                        <Image src={feature?.image?.url ?? ''} alt={feature?.title ?? ''} height={40} width={40} />
                        <Text fontStyle="um_text-sm/normal" whiteSpace="pre" color="base/primary">
                          {feature?.title}
                        </Text>
                      </Flex>
                    </Container>
                  ))}
                </Flex>
                <Container backgroundColor="base/overlay" borderRadius="radius-3xl" padding="spacing-20">
                  <Flex justifyContent="space-between" alignItems="center">
                    <Flex flexDirection="column" gap="spacing-8">
                      <Text fontStyle="um_text-xl/medium" color="base/primary">
                        Download the app
                      </Text>
                      <Text fontStyle="um_text-sm/normal" color="base/secondary">
                        For iOS and Android
                      </Text>
                    </Flex>
                    <QRCode
                      value={modalData?.qrUrl ?? ackoUrl}
                      size={120}
                      fgColor={BrandVars.text['base/primary']}
                      bgColor={BrandVars.Surface['base/overlay']}
                    />
                  </Flex>
                </Container>
              </Flex>
            </Flex>
          </Container>
          <div
            className={styles.modalMediaWrapper}
            style={{
              backgroundImage:
                'url(https://acko-cms.ackoassets.com/Ackodrive_modal_image_bottom_layer_86d4ac10f1.webp)',
            }}>
            <div
              className={styles.modalMediaFrame}
              style={{
                backgroundImage:
                  'url(https://acko-cms.ackoassets.com/Ackodrive_modal_middle_layer_image_102d7d6dd9.webp)',
              }}>
              <div className={styles.modalMediaStyle}>
                <Image
                  width={500}
                  height={500}
                  className={styles.media}
                  alt="Modal mobile image"
                  src={modalData?.image?.url ?? ''}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Container>
    </Modal>
  )
}

export default DriveModal
